var _excluded = ["options", "size", "placeholder", "isDisabled", "isReadOnly", "isViewMode", "onChange", "value", "onClick", "onKeyDown"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { isEqual } from 'lodash';
import { forwardRef } from '../../../utils';
import { BaseSelect, useMultiSelect } from '../../internal/BaseSelect';
import { Option } from './Option';
import { jsx as _jsx } from "react/jsx-runtime";
export var MultiSelect = forwardRef((_ref, ref) => {
  var {
    options: optionList,
    size = 'large',
    placeholder,
    isDisabled = false,
    isReadOnly = false,
    isViewMode = false,
    onChange,
    value,
    onClick,
    onKeyDown
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    dropdownMenuProps,
    toggleButtonProps,
    getOptionProps,
    selectedOptions
  } = useMultiSelect({
    ref,
    value,
    options: optionList,
    onClick,
    onChange,
    onKeyDown
  });
  return /*#__PURE__*/_jsx(BaseSelect, {
    "data-component": "MultiSelect",
    trigger: /*#__PURE__*/_jsx(BaseSelect.ToggleButton, _objectSpread(_objectSpread(_objectSpread({}, toggleButtonProps), props), {}, {
      selectValue: selectedOptions,
      placeholder: placeholder,
      size: size,
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      isViewMode: isViewMode
    })),
    dropdownMenu: /*#__PURE__*/_jsx(BaseSelect.DropdownMenu, _objectSpread(_objectSpread({}, dropdownMenuProps), {}, {
      renderOption: (option, index) => /*#__PURE__*/_jsx(Option, _objectSpread(_objectSpread({
        isSelected: Boolean(selectedOptions.find(o => isEqual(o.value, option.value)))
      }, getOptionProps({
        option,
        index
      })), option))
    }))
  });
});
MultiSelect.displayName = 'MultiSelect';
//# sourceMappingURL=MultiSelect.js.map